import React, { Component } from 'react';
import { Select, Modal, Button, Upload, message } from 'antd';
import { map, isEmpty } from 'lodash';
import * as yup from 'yup';
import Script from "react-load-script";
import plus_icon from '../../../../Assets/images/plus_icon.svg';
import chevron from '../../../../Assets/images/chevron.svg';
import cross_icon from '../../../../Assets/images/cross_icon.svg';
import cross_circle from '../../../../Assets/images/cross-circle.svg';
import eye from '../../../../Assets/images/eye.svg';
import eyeoff from '../../../../Assets/images/eye-off.svg';
import AllState from '../../../../Assets/data/stateList.json';
import { errorHandle } from "../../../Common/errorHandle";
import axios from 'axios';
import config from '../../../../Lib/config';

let house_type = [
  { value: 'townhomes', key: 'Townhomes' },
  { value: 'detached', key: 'Detached' },
  { value: 'condo', key: 'Condo' },
  { value: 'apartment', key: 'Apartment' },
]

const notificationOrderList = [{key: 'technician_assigned', index: 0}, {key: 'technician_enroute', index: 1},
  {key: 'service_complete', index: 2}, {key: 'service_issues', index: 3}, {key: 'billing_notifications', index: 4}]

const { Option } = Select;
class AccountInfo extends Component {
  state = {
    is_edit_info: false,
    is_submit_btn_active: false,
    loader: false,
    accountInfo: {},
    is_show_pwd: false,
    notification_list: [],
    emailaddress_set: [],
    phone_numbers: [],
    authorized_users: [],
    new_pwd: '',
    single_phone: { 'phone': '', 'can_send_sms': false, 'type': 'home_phone', 'primary': true },
    role: [],
    community_role: '',
    is_community_info: false,
    is_commercial_customer: false,
    comunnity_info: [],
    temp_community_info: {},
    is_upload: false,
    temp_properties_in_community_list: [],
    file_name: '',
    guest_notification_service: [],
    is_authorized_user: false,
    zipcodeCheck: null,
    is_address_manually: false,
    address: {
      address: '',
      city: '',
      state: '',
      zip_code: '',
      route: '',
      street_number: ''
    },
    is_print_and_mail_invoices: false,
    is_email_invoice: false
  }

  // Set price list as per invision
  arrayMove = (arr, fromIndex, toIndex) => {
    if (fromIndex && fromIndex >= 0) {
      var element = arr[fromIndex];
      arr.splice(fromIndex, 1);

      arr.splice(toIndex, 0, element);
    }
  };

  componentDidMount = () => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 300);
    this.setState({
      loader: true
    })
    //Get notification preference list
    let userKey = JSON.parse(localStorage.getItem('userKey')) || null;
    this.props.getNotification({ user__uuid: userKey?.user?.uuid });
    if (userKey) {
      this.setState({
        role: userKey?.user?.role
      })
      if (userKey?.user?.role.includes('commercial_customer')) {
        this.props.getCommericalAccountInfo(userKey?.user?.uuid);
        this.setState({
          is_commercial_customer: true
        });
        this.props.getCommunityInfo({ user__uuid: userKey?.user?.uuid })
      }
      else {
        // get user acount info
        this.props.getAccountInfo();
      }
    }
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    
    let userKey = JSON.parse(localStorage.getItem('userKey')) || null;

    //get account info
    if (Object.keys(props.AccountInfo.data).length > 0 && props.AccountInfo.data !== this.props.AccountInfo.data) {
      
      const address = {
        address: props?.AccountInfo?.data?.invoice_address?.address ? `${props?.AccountInfo?.data?.invoice_address?.address}` : '',
        city: props?.AccountInfo?.data?.invoice_address?.city ? `${props?.AccountInfo?.data?.invoice_address?.city}` : '',
        state: props?.AccountInfo?.data?.invoice_address?.state ? `${props?.AccountInfo?.data?.invoice_address?.state}` : '',
        zip_code: props?.AccountInfo?.data?.invoice_address?.zip_code ? `${props?.AccountInfo?.data?.invoice_address?.zip_code}` : '',
      }

      this.setState({
        accountInfo: props.AccountInfo.data,
        emailaddress_set: props.AccountInfo.data.emailaddress_set,
        loader: false,
        phone_numbers: props.AccountInfo.data.phone_numbers,
        authorized_users: props.AccountInfo.data.authorized_users,
        is_email_invoice: props.AccountInfo.data.is_email_invoice,
        is_print_and_mail_invoices: props.AccountInfo.data.is_print_and_mail_invoices,
        address: address
      }, () => {
        if (this.refs["address"]) {
          let addressStr = props?.AccountInfo?.data?.invoice_address?.address ? `${props?.AccountInfo?.data?.invoice_address?.address}` : '';
          addressStr += props?.AccountInfo?.data?.invoice_address?.city ? `, ${props?.AccountInfo?.data?.invoice_address?.city}` : '';
          addressStr += props?.AccountInfo?.data?.invoice_address?.state ? `, ${props?.AccountInfo?.data?.invoice_address?.state}` : '';
          addressStr += props?.AccountInfo?.data?.invoice_address?.zip_code ? `, ${props?.AccountInfo?.data?.invoice_address?.zip_code}` : '';
          this.refs["address"].value = addressStr;
        }
      })
    }

    if (Object.keys(props.AccountInfo.errors).length > 0) {
      //write a code for action on api fail
      this.setState({
        loader: false
      })
    }

    // Update User
    if (Object.keys(props.updatedUser.data).length > 0) {
      this.setState({
        accountInfo: props.updatedUser.data,
        emailaddress_set: props.updatedUser.data.emailaddress_set,
        phone_numbers: props.updatedUser.data.phone_numbers,
        authorized_users: props.updatedUser.data.authorized_users,
        // is_edit_info: false,
        loader: false
      })
    }

    if (Object.keys(props.updatedUser.errors).length > 0 && this.props?.updatedUser.errors !== props?.updatedUser?.errors) {
      //write a code for action on api fail
      message.destroy()
      this.setState({
        loader: false,
      })

      if (props.updatedUser?.errors?.[0]) {
        message.error(props.updatedUser?.errors?.[0], 10)
      } else {
        errorHandle(props?.updatedUser?.errors)
      }
    }

    //get notification list
    if (Object.keys(props.NotificationList.data).length > 0) {
      let list = [], result = props.NotificationList.data.results
      map(notificationOrderList, (obj) => {
        const data = result.filter(x => x.type === obj.key)
        if (!isEmpty(data[0])) {
          list[obj.index] = data[0]
        }
      })
      this.setState({ notification_list: list, loader: false }, () => {
        console.warn('get notifications', list);
      })
    }

    if (Object.keys(props.NotificationList.errors).length > 0) {
      //write a code for action on api fail
      this.setState({
        loader: false
      })
    }

    //Update notification list
    // if (Object.keys(props.updatedNotification.data).length > 0) {
    //   let list = [], result = props.updatedNotification.data
    //   map(notificationOrderList, (obj) => {
    //     const data = result.filter(x => x.type === obj.key)
    //     if (!isEmpty(data[0])) {
    //       list[obj.index] = data[0]
    //     }
    //   })

    //   this.setState({ notification_list: list, loader: false })
    // }

    if (Object.keys(props.updatedNotification.errors).length > 0) {
      //write a code for action on api fail
      this.setState({
        loader: false,
        new_pwd: ''
      })
    }

    //Commercial User
    if (Object.keys(props.GetCommercialInfo.data).length > 0 && props.GetCommercialInfo.data !== this.props.GetCommercialInfo.data) {
      this.setState({
        accountInfo: props.GetCommercialInfo.data,
        emailaddress_set: props.GetCommercialInfo.data.emailaddress_set,
        loader: false,
        phone_numbers: props.GetCommercialInfo.data.phone_numbers,
        community_role: props.GetCommercialInfo.data.community_role,
        authorized_users: props.AccountInfo.data.authorized_users
      })
    }

    if (Object.keys(props.GetCommercialInfo.errors).length > 0) {
      //write a code for action on api fail
      this.setState({
        loader: false
      })
    }
    
    //Update Commercial User
    if (Object.keys(props.UpdateCommercialUser.data).length > 0 && props.UpdateCommercialUser.data !== this.props.UpdateCommercialUser.data) {
      this.setState({
        loader: false,
      })
    }

    if (Object.keys(props.UpdateCommercialUser.errors).length > 0) {
      //write a code for action on api fail
      this.setState({
        loader: false
      })
    }

    //Comunnity info
    if (Object.keys(props.CommunityInfo.data).length > 0 && props.CommunityInfo.data !== this.props.CommunityInfo.data) {
      this.setState({
        comunnity_info: props.CommunityInfo.data.results,
        loader: false,
        file_name: '',
        is_upload: false
      })

      if (props.CommunityInfo.data.results.length > 0) {
        this.setState({
          guest_notification_service: props?.CommunityInfo?.data?.results[0]['guest_notification_service'].length > 0 ? props?.CommunityInfo?.data?.results[0]['guest_notification_service'] : [false, false]
        })
      }
    }

    if (Object.keys(props.CommunityInfo.errors).length > 0) {
      //write a code for action on api fail
      this.setState({
        loader: false
      })
    }

    //Update Community Info
    if (Object.keys(props.UpdateCommunity.data).length > 0 && props.UpdateCommunity.data !== this.props.UpdateCommunity.data) {
      this.props.getCommunityInfo({ user__uuid: userKey?.user?.uuid });
      this.setState({
        is_community_info: false
      })
    }
    
    if (Object.keys(props.UpdateCommunity.errors).length > 0) {
      //write a code for action on api fail
      errorHandle(props?.UpdateCommunity?.errors)
      this.setState({
        loader: false
      })
    }

    this.setState({
      loader: false
    })
  }

  // format phone number
  formatPhoneNumber = (phone) => {
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  // web simple view code start here//
  //render notification list
  renderNotification = () => {
    let { notification_list } = this.state;
    return map(notification_list, (item, i) => {
      return (
        <li key={i}>
          <label>{item?.type_display || ''}</label>
          <div className="checkbox_wrapper">
            <input type="checkbox" checked={item?.email} onChange={(e) => { this.onNotificationChange(e, item, 'email') }} />
          </div>
          <div className="checkbox_wrapper">
            <input type="checkbox" checked={item?.text} onChange={(e) => { this.onNotificationChange(e, item, 'text') }} />
          </div>
        </li>
      )
    })
  }

  //Change notification prefrence status
  onNotificationChange = (e, item, type) => {
    let { notification_list } = this.state;
    let index = notification_list.findIndex(x => x.uuid === item.uuid);
    notification_list[index][type] = e.target.checked;

    this.setState({
      notification_list
    })
  }

  //render email address list
  renderEmailAddress = () => {
    let { emailaddress_set } = this.state;

    return map(emailaddress_set && emailaddress_set, (item, i) => {
      return (
        <li key={i}>
          <div className={item.primary ? 'checkbox_wrapper primary' : 'checkbox_wrapper'}>
            <input id={`email${i}`} type="checkbox" name="email" checked={item.primary} onChange={(e) => { this.onEmailChange(e, item) }} />
            <label htmlFor={`email${i}`}>{item.email} {item.primary ? '(Primary)' : ''}</label>
          </div>
        </li>
      )
    })
  }

  //email check uncheck
  onEmailChange = (e, item) => {
    let { emailaddress_set } = this.state;

    if (e.target.checked) {
      let index = emailaddress_set.findIndex(x => x.email === item.email);
      map(emailaddress_set, (obj, i) => {
        emailaddress_set[i]['primary'] = false
      })
      emailaddress_set[index]['primary'] = true
      this.setState({
        emailaddress_set
      })
      // this.arrayMove(emailaddress_set, emailaddress_set.findIndex((x) => x.primary), 0);
    }


  }

  //render email address list
  renderPhone = () => {
    let { phone_numbers } = this.state;
    return map(phone_numbers && phone_numbers, (item, i) => {
      return (
        <li key={i}>
          <div className={item.primary ? 'checkbox_wrapper primary' : 'checkbox_wrapper'}>
            <input id={`phone${i}`} type="checkbox" checked={item.primary} onChange={(e) => { this.onPhoneChange(e, item) }} />
            <label htmlFor={`phone${i}`}>{this.formatPhoneNumber(item.phone)}{item.primary ? ' (Primary)' : ''}</label>
          </div>
        </li>
      )
    })
  }

  //phone check uncheck
  onPhoneChange = (e, item) => {
    let { phone_numbers } = this.state;

    if (e.target.checked) {
      let index = phone_numbers.findIndex(x => x.uuid === item.uuid);
      map(phone_numbers, (obj, i) => {
        phone_numbers[i]['primary'] = false
      })
      phone_numbers[index]['primary'] = true
      this.setState({
        phone_numbers
      })
      // this.arrayMove(phone_numbers, phone_numbers.findIndex((x) => x.primary), 0);
    }
  }

  ////Modal Popup code start here/////

  // add multi Authorize Users
  userNameChange = (e) => {
    let { accountInfo } = this.state;
    let temp_accountInfo = { ...accountInfo }
    Object.assign(temp_accountInfo, { [e.target.name]: e.target.value })
    this.setState({
      accountInfo: temp_accountInfo
    }, () => { this.validateForm() })
  }

  addAuthorizedUsers = (e) => {
    e.preventDefault();
    let { authorized_users } = this.state;
    if (authorized_users.length > 0) {
      authorized_users.push('');
      this.setState({
        authorized_users
      })
    }
  }

  // add more email
  addmoreEmail = (e) => {
    e.preventDefault()
    let { emailaddress_set } = this.state;
    let multi_email = {
      email: '',
      primary: false
    }

    emailaddress_set.push(multi_email);
    this.setState({ emailaddress_set })
    this.validateForm();
  }

  //Add multiple phone number
  addMorePhone = (e) => {
    e.preventDefault();
    let { phone_numbers } = this.state;
    let temp_phone = {
      phone: "", type: "home_phone", can_send_sms: false,
    }
    phone_numbers.push(temp_phone);
    this.setState({ phone_numbers })
    this.validateForm();
  }

  //remove Email and phone
  removeMultiEmailPhone = (e, id, type) => {
    e.preventDefault();
    var index = type.indexOf(id);
    type.splice(index, 1);
    this.setState({
      type
    })
    this.validateForm();
  }

  // authorized users name change
  authUSerChange = (e, key) => {
    let { authorized_users } = this.state;
    authorized_users[key] = e.target.value;
    this.setState({
      authorized_users
    })
  }

  //render Multi user
  renderMultiAuthUser = () => {
    let { authorized_users } = this.state;
    return map(authorized_users, (item, key) => {
      if (key !== 0) {
        return (
          <div className="billing_control" key={key}>
            <div className="multi_control mr-2">
              <input
                type="text"
                className="form--control"
                onChange={(e) => { this.authUSerChange(e, key) }}
                value={authorized_users[key]}
                placeholder="Authorized User" />
            </div>
            <div className="multi_control add_more_contact">
              <a href="/#" onClick={(e) => { this.removeMultiEmailPhone(e, item, authorized_users); }}><img src={cross_icon} alt="" /></a>
            </div>
          </div>
        )
      }
    })
  }

  // render Multi Email
  renderMultipleEmail = () => {
    let { emailaddress_set } = this.state;
    return map(emailaddress_set && emailaddress_set, (item, key) => {
      if (!item.primary) {
        return (<div className="billing_control" key={key}>
          <div className="multi_control mr-2">
            <input
              name={'email-' + key}
              id={'email-' + key}
              className="form--control"
              value={emailaddress_set[key].email}
              placeholder="Secondary Email"
              onChange={(e) => { this.multiEmailPhoneChange(e, key, emailaddress_set, 'email') }}
            />
          </div>
          <div className="multi_control remove_more_contact">
            <a href="/#" onClick={(e) => { this.removeMultiEmailPhone(e, item, emailaddress_set); }} className="remove_contact"><img src={cross_icon} alt="" /></a>
          </div>
        </div>)
      }
    })
  }

  // render Multi phone
  renderMultiplePhone = () => {
    let { phone_numbers } = this.state;
    return map(phone_numbers && phone_numbers, (item, key) => {
      if (!item.primary) {
        return (
          <React.Fragment key={key}>
            <div className="billing_control phone_control">
              <div className="multi_control mr-2">
                <input
                  type="text"
                  name={'phone-' + key}
                  id={'phone-' + key}
                  className="form--control"
                  value={phone_numbers[key].phone}
                  onChange={(e) => { this.multiEmailPhoneChange(e, key, phone_numbers, 'phone') }}
                  inputMode="numeric"
                  placeholder="Secondary Number"
                  onPaste={(event) => {
                    if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                      event.preventDefault();
                    }
                  }}
                  onKeyPress={(e) => {
                    const pattern = /[0-9]/;
                    const inputChar = String.fromCharCode(e.charCode);
                    if (!pattern.test(inputChar)) {
                      // invalid character, prevent input
                      e.preventDefault();
                    }
                  }}
                  max="10"
                  maxLength="10" />
              </div>
              <div className="multi_control mr-2 phone_number_type">
                <Select
                  placeholder="Type"
                  name={'type-' + key}
                  id={'type-' + key}
                  onChange={(e) => { this.multiPhoneTypeChange(e, key) }}
                  value={phone_numbers[key].type}
                  suffixIcon={<img src={chevron} alt="" />}
                >
                  <Option value="home_phone">Home</Option>
                  <Option value="mobile">Mobile</Option>
                </Select>
              </div>
              <div className="multi_control remove_more_contact"><a href="/#" className="remove_contact" onClick={(e) => { this.removeMultiEmailPhone(e, item, phone_numbers) }}><img src={cross_icon} alt="" className="remove_contact" /></a></div>
            </div>
            {phone_numbers[key].type === 'mobile' ?
              <div className="billing_control">
                <div className="checkbox_wrapper">
                  <input
                    id={'can_send_sms' + key}
                    name={'can_send_sms' + key}
                    type="checkbox"
                    checked={phone_numbers[key]['can_send_sms']}
                    onChange={(e) => {
                      let { phone_numbers } = this.state;
                      phone_numbers[key]['can_send_sms'] = e.target.checked;
                      this.setState({
                        phone_numbers
                      })
                    }}
                  />
                  <label htmlFor={'can_send_sms' + key}>Accept text messages at this number</label>
                </div>
              </div> : ''}
          </React.Fragment>

        )
      }
    })
  }

  // Multi phone email change
  multiEmailPhoneChange = (e, index, type, contact) => {
    type[index][contact] = e.target.value;
    this.setState({
      type
    })
    this.validateForm();
  }

  // phone type change
  multiPhoneTypeChange = (e, key) => {
    let { phone_numbers } = this.state;
    phone_numbers[key]['type'] = e;
    if (e === 'home_phone') {
      phone_numbers[key]['can_send_sms'] = false;
    }
    this.setState({
      phone_numbers
    })
    this.validateForm();
  }

  // open edit popup
  editPopUpAction = (e) => {
    e.preventDefault();
    this.setState({ is_edit_info: true });
    this.validateForm();
    this.props.getAccountInfo();
  }

  // password Change
  passwordChange = (e) => {
    this.setState({
      new_pwd: e.target.value
    });
    this.validateForm();
  }

  // Edit details valideation
  validateForm = () => {
    let { emailaddress_set, phone_numbers, single_phone, is_commercial_customer } = this.state;
    let { first_name, last_name, community_name, management_company, } = this.state.accountInfo;

    const UserSchema = yup.object().shape({
      is_commercial_customer: yup.boolean(),
      emailaddress_set: yup.array().of(yup.object().shape({
        email: yup.string().required().email(),
      })),
      phone_numbers: yup.array().of(yup.object().shape({
        phone: yup.string().required().length(10),
      })),
      first_name: yup.string().required(),
      last_name: yup.string().required(),
      community_name: yup.string().when("is_commercial_customer", {
        is: true,
        then: yup.string().required('Time field is required')
      }),
      management_company: yup.string().when("is_commercial_customer", {
        is: true,
        then: yup.string().required('Management company is required')
      })
    })
    const UserData = { emailaddress_set, phone_numbers, first_name, last_name, community_name, is_commercial_customer, management_company }
    // check validity
    let IsValid;
    var self = this;
    UserSchema.isValid(UserData)
      .then(function (valid) {
        IsValid = valid
      });
    setTimeout(() => {
      if (IsValid) {
        self.setState({
          errors: {}
        })
        self.setState({
          is_submit_btn_active: false
        })

        // for single phone
        if (phone_numbers.length === 0) {
          if (single_phone.phone.length > 0 && single_phone.phone.length < 10) {
            self.setState({
              is_submit_btn_active: true
            })
          }
        }

        // for Password

        if (self.state.new_pwd.length > 0) {
          let a = /[A-Z]/;
          let b = /[a-z]/;

          if (a.test(self.state.new_pwd) && b.test(self.state.new_pwd) && (/\d/).test(self.state.new_pwd) && self.state.new_pwd.length > 7) {
            self.setState({
              is_submit_btn_active: false
            })
          }

          else {
            self.setState({
              is_submit_btn_active: true
            })
          }
        }

        else {
          self.setState({
            is_submit_btn_active: false
          })
        }


      }
      else {
        UserSchema.validate(UserData, { abortEarly: false })
          .catch(function () {
            // console.log(e)
            self.setState({
              is_submit_btn_active: true
            })
          });
      }
    }, 100);
  }

  // check user details
  updateUSerCheck = (e) => {
    e.preventDefault();
    let { is_print_and_mail_invoices, address } = this.state;
    if (is_print_and_mail_invoices) {
      const schema = yup.object().shape({
        address: yup.object().shape({
          address: yup.string().required('address is required.'),
          city: yup.string().required('city is required.'),
          state: yup.string().required('state is required.'),
          zip_code: yup.string().required('zip code is required.')
        }),
      });
      const data = { address };
      schema.validate(data, {abortEarly: false}).then(() => {
        this.setState({errors: {}});
        this.updateUSer();
      }).catch(() => {
        this.setState({errors: {}});
        message.error('Please enter valid invoice address')
      })
    } else {
      this.updateUSer();
    }
  }

  // save user details
  updateUSer = () => {
    let { accountInfo, phone_numbers, emailaddress_set, authorized_users, single_phone, new_pwd, is_email_invoice, is_print_and_mail_invoices, address, is_address_manually } = this.state;
    let { first_name, last_name, field_office } = accountInfo;
    let api_payload = {
      first_name,
      last_name,
      phone_numbers,
      emailaddress_set,
      authorized_users_list: authorized_users,
      is_email_invoice: is_email_invoice,
      is_print_and_mail_invoices: is_print_and_mail_invoices,
    }
    if (is_print_and_mail_invoices) {
      api_payload['invoice_address'] = address;
    }
    // if (!authorized_users.length > 0) {
    //   delete api_payload.authorized_users_list
    // }
    if (!phone_numbers.length > 0) {
      if (single_phone.phone.length > 0) {
        phone_numbers.push(single_phone)
      }
      else {
        delete api_payload.phone_numbers
      }
    }
    if (new_pwd) {
      api_payload.password = new_pwd
    }
    this.setState({
      new_pwd: '',
      is_address_manually: false
    })
    
    this.props.updateUser(api_payload);

    // if (is_address_manually) {
    //   this.props.updateUser(api_payload);
    // } else {
    //   this.props.updateUser(api_payload);
    //   axios.post(`${config.getHost()}service-order/validate_address/`, {
    //     field_office_uuid: field_office && field_office.uuid,
    //     address: this.refs['address'].value
    //   }).then((response) => {
    //     if (Object.keys(response).length > 0 && response?.data?.is_valid) {
    //       this.props.updateUser(api_payload);
    //     } else {
    //       message.error('Sorry, we could not find that address in OptimoRoute. Please check the address and try again, or enter latitude/longitude coordinates.', 10);
    //     }
    //   }).catch(() => {
    //     message.error('Sorry, we could not find that address in OptimoRoute. Please check the address and try again, or enter latitude/longitude coordinates.', 10);
    //   });
    // }
    
    setTimeout(() => {
      this.setState({
        is_edit_info: false
      })
    }, 1000);
  }

  // save user details
  updateAuthorizedUser = (e) => {
    e.preventDefault();
    let { authorized_users, emailaddress_set, accountInfo } = this.state;
    let api_payload = {
      authorized_users_list: authorized_users,
      emailaddress_set: !isEmpty(emailaddress_set) ? emailaddress_set : [{email: accountInfo?.email, primary: true}]
    }
    this.setState({loader: true, is_authorized_user: false})
    this.props.updateUser(api_payload);
  }

  // Check community
  updateCommunityCheck = (e) => {
    e.preventDefault();
    let { is_print_and_mail_invoices, address, is_address_manually } = this.state;
    if (is_print_and_mail_invoices && is_address_manually) {
      const schema = yup.object().shape({
        address: yup.object().shape({
          address: yup.string().required('address is required.'),
          city: yup.string().required('city is required.'),
          state: yup.string().required('state is required.'),
          zip_code: yup.string().required('zip code is required.')
        }),
      });
      const data = { address };
      schema.validate(data, {abortEarly: false}).then(() => {
        this.setState({errors: {}});
        this.updateCommunity();
      }).catch(() => {
        this.setState({errors: {}});
        message.error('Please enter valid invoice address')
      })
    } else {
      this.updateCommunity();
    }
  }

  // Update community
  updateCommunity = () => {
    let { accountInfo, phone_numbers, emailaddress_set, authorized_users, single_phone, new_pwd, community_role, is_email_invoice, is_print_and_mail_invoices, address, is_address_manually } = this.state;
    let { first_name, last_name, community_name, management_company, field_office } = accountInfo;
    let api_payload = {
      first_name,
      last_name,
      phone_numbers,
      emailaddress_set,
      authorized_users_list: authorized_users,
      community_role,
      community_name, management_company,
      is_email_invoice: is_email_invoice,
      is_print_and_mail_invoices: is_print_and_mail_invoices,
    }
    if (is_print_and_mail_invoices) {
      api_payload['invoice_address'] = address;
    }
    // if (!authorized_users.length > 0) {
    //   delete api_payload.authorized_users_list
    // }
    if (!phone_numbers.length > 0) {
      if (single_phone.phone.length > 0) {
        phone_numbers.push(single_phone)
      }
      else {
        delete api_payload.phone_numbers
      }
    }
    if (new_pwd) {
      api_payload.password = new_pwd
    }

    this.setState({
      loader: true,
      new_pwd: '',
      is_address_manually: false
    })
    let userKey = JSON.parse(localStorage.getItem('userKey')) || null;
    
    if (is_address_manually) {
      //DOOD-2953 22/09/2021 Added new line of code to get user's UUID from loccalStorage
      this.props.updateCommericalAccountInfo(api_payload, userKey?.user?.uuid);
    } else {
      axios.post(`${config.getHost()}service-order/validate_address/`, {
        field_office_uuid: field_office && field_office.uuid,
        address: this.refs['address'].value
      }).then((response) => {
        if (Object.keys(response).length > 0 && response?.data?.is_valid) {
          //DOOD-2953 22/09/2021 Comment the code as  wont be able to get uuid from accountInfo object
          //this.props.updateCommericalAccountInfo(api_payload, accountInfo.uuid);
  
          //DOOD-2953 22/09/2021 Added new line of code to get user's UUID from loccalStorage
          this.props.updateCommericalAccountInfo(api_payload, userKey?.user?.uuid);
        } else {
          message.error('Sorry, we could not find that address in OptimoRoute. Please check the address and try again, or enter latitude/longitude coordinates.', 10);
        }
      }).catch(() => {
        message.error('Sorry, we could not find that address in OptimoRoute. Please check the address and try again, or enter latitude/longitude coordinates.', 10);
      });
    }

    setTimeout(() => {
      this.setState({
        is_edit_info: false
      })
    }, 1000);
  }

  onDocumentLoadSuccess = () => {

  }

  //Render Comunity Info
  renderCommunityInfo = () => {
    let { comunnity_info } = this.state;
    return map(comunnity_info, (item, i) => {

      return (
        <div className="col-md-6 col-lg-5 col-xl-4" key={i}>

          <div className="service_card user_Details">
            <div className="header">
              <span className="title">Community Info</span>
              <a href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  this.setState({
                    is_community_info: true,
                    temp_properties_in_community_list: comunnity_info[i]['properties_in_community'] || [],
                    temp_community_info: comunnity_info[i]
                  })
                }}>Edit</a>
            </div>

            <div className="body">
              <div className="account_info_table">
                <table>
                  <thead>
                    <tr>
                      <th>House Types: </th>
                      <th style={{ textTransform: 'capitalize' }}>
                        {item.properties_in_community && item.properties_in_community.length > 0 ? item.properties_in_community.join(',') : '-'}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Number of Homes:</td>
                      <td>{item?.home_count ? item?.home_count : '-'}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <b>Community Boundary Map:</b>
              <div className="customer_community_map">

                {item?.community_boundary_map ?
                  <div className="embed-block">
                    <embed
                      src={`${item?.community_boundary_map}#toolbar=0&navpanes=0&statusbar=0&scrollbar=0&pagemode=bookmarks&#zoom=100&page=1&view=fitH,100 `}
                      type="application/pdf"
                    ></embed>
                  </div>
                  : ''}
                <ul>
                  <li><label>{item?.community_boundary_map ? item?.community_boundary_map.split('?')[0].split('/')[3] : ''}</label></li>
                  <li><a href="/#" onClick={(e) => {
                    e.preventDefault();
                    this.setState({
                      is_community_info: true,
                      temp_properties_in_community_list: comunnity_info[i]['properties_in_community'] || [],
                      temp_community_info: comunnity_info[i]
                    })
                  }}>Update Map</a></li>
                </ul>


                <b>Sample Address in the Community:</b>
                <p>{item.address ? `${item.address?.address}, ${item.address?.city}, ${item.address?.state}, ${item.address?.zip_code}` : '-'}</p>


                <a href="/#" onClick={(e) => {
                  e.preventDefault();
                  this.setState({
                    is_community_info: true,
                    temp_properties_in_community_list: comunnity_info[i]['properties_in_community'] || [],
                    temp_community_info: comunnity_info[i]
                  })
                }}>Update Community Details</a>
              </div>
            </div>

          </div>
        </div>
      )
    })
  }

  //Update Community Info
  updateCommunityInfo = () => {
    let { temp_community_info, temp_properties_in_community_list, is_upload } = this.state;

    temp_properties_in_community_list = temp_properties_in_community_list.filter(function (el) {
      return el !== '';
    });

    let temp_address = temp_community_info.address;
    delete temp_address.geo_location;


    let data = {
      uuid: temp_community_info?.uuid,
      community_boundary_map: temp_community_info.community_boundary_map || '',
      address: temp_address,
      home_count: temp_community_info?.home_count,
      properties_in_community: temp_properties_in_community_list
    }

    if (!is_upload) {
      delete data.community_boundary_map;
    }

    this.setState({
      loader: true
    })

    setTimeout(() => {
      this.props.updateCommunityInfo(data);
    }, 100);

  }

  //Update Commuinity address'
  updateCommunityAddress = (e, type) => {
    let { temp_community_info } = this.state;
    let { address } = temp_community_info;

    if (address === null) {
      address = { state: '', city: '', zip_code: '', address: '' }
    }

    if (type === "state") {
      address = Object.assign(address, { [type]: e });
    }
    else {
      address = Object.assign(address, { [type]: e.target.value });
    }

    temp_community_info = Object.assign(temp_community_info, { address });

    this.setState({
      temp_community_info
    })
  }

  // render all state
  renderAllState = () => {
    return map(AllState, (item, i) => {
      return (<Option value={item.abbreviation} key={i}>{item.name}</Option>)
    })
  }

  // on address change
  onAddressChanged = (e) => {
    const { address } = this.state;
    Object.assign(address, { [e.target.name]: e.target.value });
    this.setState({ address }, () => console.warn('address set...'));
  };

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // Google Map Place API
  handleScriptLoad = () => {

    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_address'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newAutoComplete.setFields(['address_components', 'formatted_address', "geometry", "icon", "name"]);

    // Fire Event when a suggested name is selected
    newAutoComplete.addListener('place_changed', this.handlePlaceSelect);

    this.setState({
      autocomplete: newAutoComplete,
    })
  };

  handlePlaceSelect = () => {
    const { autocomplete } = this.state;
    const addressObject = autocomplete.getPlace();
    const address = addressObject.address_components;
    let obj = {};
    if (address) {
      map(addressObject?.address_components, (item) => {
        if (item?.types?.includes('administrative_area_level_2')) {
          obj = Object.assign(obj, { 'address': item.short_name })
        }
        if (item?.types?.includes('route')) {
          obj = Object.assign(obj, { 'route': item.short_name })
        }
        if (item?.types?.includes('street_number')) {
          obj = Object.assign(obj, { 'street_number': item.short_name })
        }
        if (item?.types?.includes('administrative_area_level_1')) {
          obj = Object.assign(obj, { 'state': item.short_name })
        }
        if (item?.types?.includes('locality')) {
          obj = Object.assign(obj, { 'city': item.long_name })
        }
        if (item?.types?.includes('postal_code')) {
          obj = Object.assign(obj, { 'zip_code': item.short_name })
        }
      });
      this.setState({ 
        address: (obj?.street_number || obj?.route) ? {...obj, address: `${obj?.street_number || ''} ${obj?.route || ''}`} : obj }, () => {
        if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
          message.error('Please enter valid address')
        }
        this.validate();
      });
    }
  }

  validate = () => {
    const { address } = this.state;
    setTimeout(() => {
      const schema = yup.object().shape({
        address: yup.object().shape({
          address: yup.string().required("Address is required"),
          state: yup.string().required("State is required"),
          city: yup.string().required("City is required"),
          zip_code: yup.string().required("Zipcode is required")
        }),
      })

      const data = { address };
      schema.validate(data, { abortEarly: false }).then(() => {
        //TODO:
      }).catch(() => {
        //TODO:
      });
    }, 500);
  }

  // on print invoice change
  onPrintInvoiceChange = (e) => {
    const { address } = this.state;
    const invoice_address = {
      address: address?.address ? `${address?.address}` : '',
      city: address?.city ? `${address?.city}` : '',
      state: address?.state ? `${address?.state}` : '',
      zip_code: address?.zip_code ? `${address?.zip_code}` : '',
    }
    if (e) {
      setTimeout( () => {
        if (this.refs["address"]) {
          let addressStr = address?.address ? `${address?.address}` : '';
          addressStr += address?.city ? `, ${address?.city}` : '';
          addressStr += address?.state ? `, ${address?.state}` : '';
          addressStr += address?.zip_code ? `, ${address?.zip_code}` : '';
          this.refs["address"].value = addressStr;
        }
      });
      this.setState({
        is_print_and_mail_invoices: true,
        invoice_address: invoice_address
      });
    } else {
      this.refs["address"].value = null;
      this.setState({
        is_print_and_mail_invoices: false,
        invoice_address: invoice_address
      });
    }
  }

  closeManualAddress = () => {
    if (Object.keys(this.props?.AccountInfo?.data).length > 0) {
      const address = {
        address: this.props?.AccountInfo?.data?.invoice_address?.address ? `${this.props?.AccountInfo?.data?.invoice_address?.address}` : '',
        city: this.props?.AccountInfo?.data?.invoice_address?.city ? `${this.props?.AccountInfo?.data?.invoice_address?.city}` : '',
        state: this.props?.AccountInfo?.data?.invoice_address?.state ? `${this.props?.AccountInfo?.data?.invoice_address?.state}` : '',
        zip_code: this.props?.AccountInfo?.data?.invoice_address?.zip_code ? `${this.props?.AccountInfo?.data?.invoice_address?.zip_code}` : '',
      }
      this.setState({
        address: address
      }, () => {
        if (this.refs["address"]) {
          let addressStr = this.props?.AccountInfo?.data?.invoice_address?.address ? `${this.props?.AccountInfo?.data?.invoice_address?.address}` : '';
          addressStr += this.props?.AccountInfo?.data?.invoice_address?.city ? `, ${this.props?.AccountInfo?.data?.invoice_address?.city}` : '';
          addressStr += this.props?.AccountInfo?.data?.invoice_address?.state ? `, ${this.props?.AccountInfo?.data?.invoice_address?.state}` : '';
          addressStr += this.props?.AccountInfo?.data?.invoice_address?.zip_code ? `, ${this.props?.AccountInfo?.data?.invoice_address?.zip_code}` : '';
          this.refs["address"].value = addressStr;
        }
      })
    }
  }

  // on email invoice change
  onEmailInvoiceChange = (e) => {
    if (e.target.checked) {
      this.setState({
        is_email_invoice: e.target.checked,
      })
    } else {
      this.setState({
        is_email_invoice: e.target.checked,
      })
    }
  }

  render() {
    let { is_edit_info, notification_list, accountInfo, emailaddress_set, phone_numbers,
      loader, is_submit_btn_active, authorized_users, single_phone, is_show_pwd, new_pwd,
      role, is_community_info, community_role, comunnity_info, temp_community_info,
      temp_properties_in_community_list, file_name, guest_notification_service, is_authorized_user, is_address_manually, address, is_print_and_mail_invoices, is_email_invoice } = this.state;
    let userKey = JSON.parse(localStorage.getItem('userKey')) || null;
    return (
      <div className="account_info_wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-5 col-xl-4 ">
              <div className="service_card user_Details">
                <div className="header">
                  <span className="title">Account Info</span>
                  <a href="/#" onClick={(e) => { this.editPopUpAction(e) }}>Edit</a>
                </div>
                <div className="body">
                  <div className="account_info_table">
                    <table>
                      <thead>
                        <tr>
                          <th>Primary User :</th>
                          <th>
                            {accountInfo ? `${accountInfo.first_name || '-'} ${accountInfo.last_name || '-'}` : ""}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          {role.includes('commercial_customer') ?
                            <td>Guest Users :</td> : <td>Authorized Users :</td>
                          }
                          <td>{accountInfo.authorized_users && accountInfo.authorized_users.length > 0 ? accountInfo.authorized_users.join(',') : '-'}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <a href="/#" onClick={(e) => { e.preventDefault(); this.setState({is_authorized_user: true}) }} className="action_link">Add Authorized Users</a>


                  {
                    role.includes('commercial_customer') ?
                      <div className="account_info_table mt-2">
                        <table>
                          <thead>
                            <tr>
                              <th>Management Company :</th>
                              <th>
                                {accountInfo?.management_company}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Community Name :</td>
                              <td>{accountInfo?.community_name}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      : ''}

                  <div className="contact_details">
                    <label className="title">Email Address:</label>
                    <ul className="contact_details_list">
                      {this.renderEmailAddress()}
                    </ul>

                    <label className="title">Primary Phone:</label>
                    <ul className="contact_details_list  list_2 ">
                      {this.renderPhone()}
                    </ul>
                  </div>

                  <a href="/#" onClick={(e) => { this.editPopUpAction(e); }} className="action_link">Update Contact Details</a>

                </div>
              </div>
            </div>

            {
              role.includes('commercial_customer') ?
                this.renderCommunityInfo()
                : ''}
            <div className="col-md-6 col-lg-5 col-xl-4 show-md" >
              <div className="service_card notification_details">
                <div className="header">
                  <span className="title">Notification Preferences</span>
                </div>
                <div className="body">
                  <ul className={notification_list.length > 0 ? 'notification_list' : 'd-none'}>
                    <li>
                      <label></label>
                      <span className="heading_text">Email</span>
                      <span className="heading_text">Text</span>
                    </li>
                    {this.renderNotification()}
                  </ul>

                  {
                    role.includes('commercial_customer') ?
                      <div className="guest_notification mt-2">
                        <h5>Notification Preferences (Guest Users)</h5>
                        {comunnity_info.length > 0 ?
                          <ul className="notification_list">
                            <li>
                              <label>Service Complete</label>
                              <div className="checkbox_wrapper">
                                <input
                                  type="checkbox"
                                  onChange={(e) => {
                                    guest_notification_service[0] = e.target.checked;

                                    this.setState({
                                      guest_notification_service
                                    })
                                  }}
                                  checked={comunnity_info[0]['guest_notification_service'][0]}
                                />
                              </div>
                              <div className="checkbox_wrapper">
                                <input
                                  type="checkbox"
                                  checked={comunnity_info[0]['guest_notification_service'][1]}

                                  onChange={(e) => {
                                    guest_notification_service[1] = e.target.checked;

                                    this.setState({
                                      guest_notification_service
                                    })
                                  }}

                                />
                              </div>
                            </li>
                          </ul>
                          : ''}
                      </div>
                      : ''}



                  <button className="btn btn--secondary"
                    disabled={notification_list?.length === 0}
                    onClick={() => {
                      this.props.updateNotification(notification_list);
                      if (role.includes('commercial_customer')) {
                        let data = {
                          uuid: comunnity_info[0]['uuid'],
                          guest_notification_service
                        }
                        this.props.updateCommunityInfo(data);
                      }
                      this.setState({ loader: true })
                    }}>Save changes</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Account info modal */}
        <Modal
          className="user_details_pupup "
          visible={is_edit_info}
          footer={[role.includes('commercial_customer') ?
            <React.Fragment>
              <Button key="cancel"
                className="btn btn-outline--primary"
                onClick={() => {
                  this.setState({ is_edit_info: false, new_pwd: '', is_address_manually: false });
                  this.props.getCommericalAccountInfo(userKey?.user?.uuid)
                }}>Cancel</Button>,
              <Button
                key="submit" className="btn btn--secondary"
                disabled={is_submit_btn_active}

                onClick={(e) => { this.updateCommunityCheck(e) }}>Save Changes</Button>
            </React.Fragment> :
            <React.Fragment>
              <Button className="btn btn-outline--primary" onClick={() => { this.setState({ is_edit_info: false, new_pwd: '', is_address_manually: false }); }}>Cancel</Button>,
              <Button className="btn btn--secondary" disabled={is_submit_btn_active} onClick={(e) => { this.updateUSerCheck(e) }}>Save Changes</Button>
            </React.Fragment>
          ]}
        >
          <div className="moday_body">
            <h4 className="modal_title">Edit Account Information</h4>
            <div className="billing_form">
              <div className="billing_control phone_control">
                <div className="multi_control mr-2">
                  <label className="control_label">First Name</label>
                  <input type="text"
                    className="form--control"
                    name="first_name"
                    onChange={(e) => { this.userNameChange(e) }}
                    value={accountInfo ? accountInfo.first_name : ''}
                    placeholder="First Name" />
                </div>
                <div className="multi_control">
                  <label className="control_label">Last Name</label>
                  <input type="text"
                    className="form--control"
                    name="last_name"
                    onChange={(e) => { this.userNameChange(e) }}
                    value={accountInfo ? accountInfo.last_name : ''}
                    placeholder="Last Name" />
                </div>
                {role.includes('commercial_customer') ?
                  <div className="multi_control ml-2 phone_number_type" style={{ maxWidth: '200px' }}>
                    <label className="control_label">Role</label>
                    <Select
                      value={community_role}
                      onChange={(e) => { this.setState({ community_role: e }) }}
                    >
                      <Option value="board_member">Board Member</Option>
                      <Option value="community_manager">Community Manager</Option>
                      <Option value="concerned_resident">Concerned Resident</Option>
                    </Select>
                  </div>
                  : ''}
              </div>
            </div>
            {
              role.includes('commercial_customer') ?

                <div className="billing_form mt-20">

                  <div className="billing_control">
                    <div className="multi_control mr-2">
                      <label className="control_label">Management Company:</label>
                      <input type="text"
                        value={accountInfo?.management_company}
                        onChange={(e) => { this.userNameChange(e) }}
                        name='management_company'
                        className="form--control"
                        placeholder="Management Company" />
                    </div>
                    <div className="multi_control">
                      <label className="control_label">Community Name:</label>
                      <input
                        type="text"
                        className="form--control"
                        value={accountInfo?.community_name}
                        onChange={(e) => { this.userNameChange(e) }}
                        name='community_name'
                        placeholder="Community Name" />
                    </div>
                  </div>
                </div>
                : ''}

            <div className="billing_form mt-20">
              <div className="billing_control">
                <label className="control_label">Email Address</label>
              </div>

              {/* Display primary email */}

              {
                map(emailaddress_set && emailaddress_set, (item, key) => {
                  if (item.primary) {
                    return (<div className="billing_control" key={key}>
                      <div className="multi_control mr-2">
                        <input type="email"
                          className="form--control"
                          value={emailaddress_set[key]['email']}
                          name={'email-' + key}
                          onChange={(e) => { this.multiEmailPhoneChange(e, key, emailaddress_set, 'email') }}
                          placeholder="Primary Email " />
                      </div>
                      {/* <div className="multi_control add_more_contact">
                        <a onClick={(e) => { this.addmoreEmail(e); }} href="/#"><img src={plus_icon} alt="" /></a>
                      </div> */}
                    </div>)
                  }
                })
              }

              {/* render multi email */}
              {this.renderMultipleEmail()}
            </div>

            {/* <div className="billing_form mt-20">
              <div className="billing_control">
                <label className="control_label">Password</label>
              </div>
              <div className="billing_control">
                <div className="single_control positin_relative">
                  <input
                    type={is_show_pwd ? 'text' : 'password'}
                    className="form--control"
                    name="new_pwd"
                    value={new_pwd}
                    autoComplete="new-password"
                    onChange={(e) => { this.passwordChange(e) }}
                    placeholder="Password" />
                  <div className="eye-icon" onClick={() => { this.setState({ is_show_pwd: !this.state.is_show_pwd }) }}>
                    {is_show_pwd ? <img src={eyeoff} alt="" /> : <img src={eye} alt="" />}
                  </div>
                </div>
              </div>
            </div> */}

            <div className="billing_form mt-20">
              <div className="billing_control">
                <label className="control_label">Phone Number</label>
              </div>
              {/* display primary number */}


              {phone_numbers.length > 0 ?
                map(phone_numbers && phone_numbers, (item, key) => {
                  if (item.primary) {
                    return (
                      <React.Fragment key={key}>
                        <div className="billing_control phone_control">
                          <div className="multi_control mr-2">
                            <input type="text"
                              inputMode="numeric"
                              name={'phone-' + key}
                              value={phone_numbers[key]['phone']}
                              onChange={(e) => { this.multiEmailPhoneChange(e, key, phone_numbers, 'phone') }}
                              className="form--control mr-2"
                              placeholder="Primary Number"
                              onPaste={(event) => {
                                if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                                  event.preventDefault();
                                }
                              }}
                              onKeyPress={(e) => {
                                const pattern = /[0-9]/;
                                const inputChar = String.fromCharCode(e.charCode);
                                if (!pattern.test(inputChar)) {
                                  // invalid character, prevent input
                                  e.preventDefault();
                                }
                              }}
                              max="10" maxLength="10" />
                          </div>
                          <div className="multi_control mr-2 phone_number_type">
                            <Select
                              placeholder="Type"
                              value={phone_numbers[key]['type']}
                              onChange={(e) => { this.multiPhoneTypeChange(e, key) }}
                              suffixIcon={<img src={chevron} alt="" />}
                            >
                              <Option value="home_phone">Home</Option>
                              <Option value="mobile">Mobile</Option>
                            </Select>
                          </div>
                          <div className="multi_control add_more_contact"><a href="/#" onClick={(e) => { this.addMorePhone(e); }}><img src={plus_icon} alt="" /></a></div>
                        </div>
                        {item.type === 'mobile' ?
                          <div className="billing_control">
                            <div className="checkbox_wrapper">
                              <input id="can_send_sms"
                                onChange={(e) => {
                                  phone_numbers[key]['can_send_sms'] = e.target.checked;
                                  this.setState({ phone_numbers })
                                }}
                                checked={phone_numbers[key]['can_send_sms']}
                                name="can_send_sms"
                                type="checkbox" />
                              <label htmlFor="can_send_sms">Accept text messages at this number</label>
                            </div>
                          </div> : ''}
                        <div>
                          <div className="checkbox_wrapper mb-10">
                            <input
                              type="checkbox" 
                              id={`printInvoice`}
                              name={`is_print_and_mail_invoices`}
                              checked={is_print_and_mail_invoices}
                              onChange={(e) => this.onPrintInvoiceChange(e.target.checked)}
                            />
                            <label htmlFor="is_print_and_mail_invoices">Print and Mail Invoice</label>
                          </div>
                          <div className="checkbox_wrapper mb-10">
                            <input
                              type="checkbox" 
                              id={`emailInvoice`}
                              name={`is_email_invoice`}
                              checked={is_email_invoice}
                              onChange={(e) => this.onEmailInvoiceChange(e)}
                            />
                            <label htmlFor="is_email_invoice">Email Invoice</label>
                          </div>
                            
                          { is_print_and_mail_invoices && 
                              <div className="google_search_place mb-10">
                                <Script
                                  url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
                                  onLoad={this.handleScriptLoad}
                                />

                                <input
                                  autoComplete="off"
                                  type="text"
                                  ref="address"
                                  className='form--control'
                                  placeholder="Search for address"
                                  name="google_address"
                                  id="google_address"
                                  onChange={(e) => {
                                    if (!e.target.value) {
                                      this.setState({
                                        address: { address: '', state: '', city: '', zip_code: '', route: '', street_number: '' },
                                      })
                                    }
                                  }}
                                  disabled={is_address_manually}
                                />
                                <b>or <a href="/" onClick={(e) => {
                                  e.preventDefault();
                                  this.setState({
                                    is_address_manually: true,
                                    address: { address: '', state: '', city: '', zip_code: '', route: '', street_number: '' },
                                  }, () => {
                                    if (this.refs['address']) {
                                      this.refs['address'].value = '';
                                    }
                                    // this.validate()
                                  })
                                }}><u>enter address manually</u></a></b>
                              </div>
                          }
                          {
                            is_address_manually && is_print_and_mail_invoices &&
                              <div className="manually_address">
                                <a href="/#" onClick={(e) => {
                                  e.preventDefault();
                                  this.setState({
                                    is_address_manually: false,
                                    address: { address: '', state: '', city: '', zip_code: '', route: '', street_number: '' },
                                  });
                                  this.closeManualAddress();
                                }}><img src={cross_icon} alt="" className="float-right mb-10" /></a>
                                <br />
                                <div className="multi_control mb-10">
                                  <input
                                    type="text"
                                    className="form--control"
                                    placeholder="Address"
                                    name="address"
                                    value={address?.address}
                                    onChange={(e) => this.onAddressChanged(e)}
                                  />
                                </div>
                                <div className="billing_control phone_control">
                                  <div className="multi_control mr-2">
                                    <input
                                      type="text"
                                      className="form--control"
                                      placeholder="City"
                                      name="city"
                                      value={address?.city}
                                      onChange={(e) => this.onAddressChanged(e)}
                                    />
                                  </div>
                                  <div className="multi_control mr-2">
                                    <Select
                                      name="state"
                                      placeholder="State"
                                      onChange={(value) => this.onAddressChanged({ target: { name: 'state', value: value } })}
                                      value={address?.state || undefined}
                                      virtual={false}
                                    >
                                      {this.renderAllState()}
                                    </Select>
                                  </div>
                                </div>
                                <div className="multi_control">
                                  <input
                                    type="text"
                                    className='form--control'
                                    placeholder="ZIP Code"
                                    name="zip_code"
                                    maxLength={5}
                                    minLength={5}
                                    onChange={(e) => this.onNumericInputChange(e.target.value) && this.onAddressChanged(e)}
                                    value={address?.zip_code || ''}
                                  />
                                </div>
                              </div>
                          }
                        </div>
                      </React.Fragment>
                    )
                  }
                })
                :
                <React.Fragment>
                  <div className="billing_control phone_control">
                    <div className="multi_control mr-2">
                      <input type="text"
                        inputMode="numeric"
                        className="form--control mr-2"
                        placeholder="Primary Number"
                        value={single_phone.phone}
                        onChange={(e) => {
                          Object.assign(single_phone, { 'phone': e.target.value })
                          this.setState({
                            single_phone
                          })
                          this.validateForm();
                        }}
                        onPaste={(event) => {
                          if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                            event.preventDefault();
                          }
                        }}
                        onKeyPress={(e) => {
                          const pattern = /[0-9]/;
                          const inputChar = String.fromCharCode(e.charCode);
                          if (!pattern.test(inputChar)) {
                            // invalid character, prevent input
                            e.preventDefault();
                          }
                        }}
                        max="10" maxLength="10" />
                    </div>
                    <div className="multi_control mr-2 phone_number_type">
                      <Select
                        placeholder="Type"
                        value={single_phone.type}
                        onChange={(e) => {
                          Object.assign(single_phone, { 'type': e })
                          this.setState({
                            single_phone
                          })
                          this.validateForm()
                        }}
                        suffixIcon={<img src={chevron} alt="" />}
                      >
                        <Option value="home_phone">Home</Option>
                        <Option value="mobile">Mobile</Option>
                      </Select>
                    </div>
                    <div className="multi_control add_more_contact"><a href="/#" onClick={(e) => { this.addMorePhone(e); }}><img src={plus_icon} alt="" /></a></div>
                  </div>
                  {single_phone.type === 'mobile' ?
                    <div className="billing_control">
                      <div className="checkbox_wrapper">
                        <input id="can_send_sms"
                          onChange={(e) => {
                            Object.assign(single_phone, { 'can_send_sms': e.target.checked })
                            this.setState({
                              single_phone
                            });
                            this.validateForm()
                          }}
                          value={single_phone.can_send_sms}
                          name="can_send_sms"
                          type="checkbox" />
                        <label htmlFor="can_send_sms">Accept text messages at this number</label>
                      </div>
                    </div>
                    : ''}
                </React.Fragment>
              }

              {this.renderMultiplePhone()}

            </div>
          </div>
        </Modal>

        {/* Add authorized modal */}
        <Modal
          className="user_details_pupup "
          visible={is_authorized_user}
          footer={
            <React.Fragment>
              <Button className="btn btn-outline--primary" onClick={() => { this.setState({ is_authorized_user: false }); this.props.getAccountInfo() }}>Cancel</Button>,
              <Button className="btn btn--secondary" disabled={is_submit_btn_active} onClick={(e) => { this.updateAuthorizedUser(e) }}>Save Changes</Button>
            </React.Fragment>}
        >
          <div className="moday_body">
            <h4 className="modal_title">Edit Authorized Users</h4>
            <div className="billing_form">
              <div className="billing_control">
                <div className="multi_control mr-2">
                  <input
                    type="text"
                    className="form--control"
                    value={authorized_users && authorized_users.length > 0 ? authorized_users[0] : ''}
                    onChange={(e) => {
                      if (authorized_users.length > 0) {
                        authorized_users[0] = e.target.value;
                      }
                      else {
                        authorized_users.push('');
                      }

                      this.setState({
                        authorized_users
                      })
                    }}
                    placeholder="Authorized User" />
                </div>
                <div className="multi_control add_more_contact">
                  <a href="/#" onClick={(e) => { this.addAuthorizedUsers(e); }}><img src={plus_icon} alt="" /></a>
                </div>
              </div>

              {this.renderMultiAuthUser()}
            </div>

          </div>
        </Modal>

        {/* Community Info modal*/}

        {comunnity_info.length > 0}{
          <Modal
            className="user_details_pupup community_info_modal"
            visible={is_community_info}
            footer={[
              <Button key="cancel" className="btn btn-outline--primary" onClick={() => {
                this.props.getCommunityInfo({ user__uuid: userKey?.user?.uuid });
                this.setState({ temp_community_info: {}, is_community_info: false, loader: true });
              }}>Cancel</Button>,
              <Button
                disabled={temp_properties_in_community_list.length > 0 && temp_community_info?.address?.address && temp_community_info?.address?.city && temp_community_info?.address?.state && temp_community_info?.address?.zip_code ? false : true}
                key="submit"
                className="btn btn--secondary" onClick={() => { this.updateCommunityInfo() }} >Save Changes</Button>
            ]}
          >

            <div className="moday_body">
              <h4 className="modal_title">Edit Community Information</h4>
              <h5>House Types</h5>
              <div className="billing_form mt-2">

                {temp_properties_in_community_list.length > 0 ?
                  <React.Fragment>
                    {
                      map(temp_properties_in_community_list, (item, i) => {
                        return (
                          <div className="billing_control phone_control" key={i}>
                            <div className="multi_control mr-2 phone_number_type">
                              <Select
                                placeholder="House Types"
                                onChange={(e) => {
                                  temp_properties_in_community_list[i] = e;
                                  this.setState({
                                    temp_properties_in_community_list
                                  })
                                }}
                                value={item}
                                suffixIcon={<img src={chevron} alt="" />}
                              >
                                {
                                  map(house_type, (item) => {
                                    if (!temp_properties_in_community_list.includes(item.value)) {
                                      return (
                                        <Option value={item.value} key={item.key}>{item.key}</Option>
                                      )
                                    }
                                  })
                                }
                              </Select>
                            </div>
                            <div className="multi_control remove_more_contact">
                              {i === 0 ?

                                <a href="/#" onClick={(e) => {
                                  e.preventDefault();
                                  temp_properties_in_community_list.push("");
                                  this.setState({
                                    temp_properties_in_community_list
                                  })

                                }} className="add_more_contact">
                                  <img src={plus_icon} alt="" /></a> :
                                <a href="/#" onClick={(e) => {
                                  e.preventDefault();
                                  var index = temp_properties_in_community_list.indexOf(item);
                                  if (index !== -1) {
                                    temp_properties_in_community_list.splice(index, 1);
                                  }
                                  this.setState({
                                    temp_properties_in_community_list
                                  })

                                }} className="add_more_contact">
                                  <img src={cross_circle} alt="" />
                                </a>
                              }
                            </div>
                          </div>
                        )
                      })
                    }
                  </React.Fragment>
                  :
                  <div className="billing_control phone_control">
                    <div className="multi_control mr-2 phone_number_type">
                      <Select
                        placeholder="House Types"
                        onChange={(e) => {
                          temp_properties_in_community_list[0] = e;
                          this.setState({
                            temp_properties_in_community_list
                          })

                        }}
                        value={temp_properties_in_community_list[0]}
                        suffixIcon={<img src={chevron} alt="" />}
                      >
                        {
                          map(house_type, (item, i) => {
                            if (!temp_properties_in_community_list.includes(item.value)) {
                              return (
                                <Option value={item.value} key={i}>{item.key}</Option>
                              )
                            }

                          })
                        }
                      </Select>
                    </div>
                    <div className="multi_control remove_more_contact">
                      <a href="/#" onClick={(e) => {
                        e.preventDefault();
                        temp_properties_in_community_list.push("");
                        this.setState({
                          temp_properties_in_community_list
                        })

                      }} className="add_more_contact">
                        <img src={plus_icon} alt="" /></a>
                    </div>
                  </div>
                }
              </div>

              <h5>Number of Homes:</h5>
              <div className="billing_form mt-2 ">
                <div className="billing_control phone_control">
                  <Select
                    suffixIcon={<img src={chevron} alt="" />}
                    value={temp_community_info?.home_count && temp_community_info?.home_count}

                    onChange={(e) => {
                      temp_community_info = Object.assign(temp_community_info, { home_count: e });
                      this.setState({
                        temp_community_info
                      })
                    }}
                    placeholder="Number of Homes">
                    <Option value="1-100">1-100</Option>
                    <Option value="101-350">101-350</Option>
                    <Option value="351-500">351-500</Option>
                    <Option value="501+">501+ </Option>
                  </Select>
                </div>
              </div>

              <div className="old_map">
                <h5 className="mb-2">Community Boundary Map:</h5>

                {
                  temp_community_info?.community_boundary_map ?
                    <React.Fragment>
                      <div className="embed-block">
                        <embed
                          src={`${temp_community_info?.community_boundary_map}#toolbar=0&navpanes=0&statusbar=0&scrollbar=0&pagemode=bookmarks&#zoom=100&page=1`}
                          type="application/pdf"
                        ></embed>
                      </div>
                      <span className="file_name"><img src={cross_icon} alt=""
                        onClick={() => {
                          temp_community_info = Object.assign(temp_community_info, { community_boundary_map: '' });
                          this.setState({
                            temp_community_info,
                            file_name: '',
                            is_upload: true
                          })
                        }} />{file_name ? file_name : temp_community_info?.community_boundary_map ? temp_community_info?.community_boundary_map.split('?')[0].split('/')[3] : ''}</span>

                    </React.Fragment>

                    :
                    <Upload
                      className="upload_community_img"
                      showUploadList={false}
                      accept="application/pdf"

                      customRequest={({ file, onSuccess }) => {
                        console.log("file:::>", file)
                        setTimeout(() => {
                          onSuccess("ok");
                        }, 0);
                      }}
                      beforeUpload={(newFileList) => {
                        var fileReader = new FileReader();
                        var base64;
                        var self = this;
                        // Onload of file read the file content
                        fileReader.onload = function (fileLoadedEvent) {
                          base64 = fileLoadedEvent?.target?.result;
                          temp_community_info = Object.assign(temp_community_info, { community_boundary_map: `data:application/pdf;df:${newFileList?.name.split('.')[0]};base64,${base64.split(',')[1]}` });
                          self.setState({
                            temp_community_info,
                            is_upload: true,
                            file_name: newFileList?.name
                          })
                        };
                        // // Convert data to base64
                        fileReader.readAsDataURL(newFileList);
                      }}
                    >
                      <Button>Drag and drop your files or  <u>&nbsp;click here&nbsp;</u>  to upload.</Button>
                    </Upload>
                }
              </div>

              <h5 className="mt-3">Sample Address in the Community:</h5>
              <div className="billing_form mt-2">
                <div className="billing_control">
                  <input
                    type="text"
                    placeholder="Address"
                    name="address"
                    onChange={(e) => { this.updateCommunityAddress(e, 'address') }}
                    value={temp_community_info?.address?.address || ''}
                    className="form--control" />
                </div>

                <div className="billing_control phone_control">
                  <div className="multi_control mr-2">
                    <input
                      name="city"
                      onChange={(e) => { this.updateCommunityAddress(e, 'city') }}
                      value={temp_community_info?.address?.city || ''}
                      type="text" placeholder="City" className="form--control" />
                  </div>
                  <div className="multi_control phone_number_type mr-2">
                    <Select
                      name="state"
                      onChange={(e) => { this.updateCommunityAddress(e, 'state') }}
                      value={temp_community_info?.address?.state || ''}
                      suffixIcon={<img src={chevron} alt="" />}
                      placeholder="State">
                      {
                        map(AllState, (item, i) => {
                          return (<Option value={item.abbreviation} key={i}>{item.abbreviation}</Option>)
                        })
                      }
                    </Select>
                  </div>
                  <div className="multi_control">
                    <input
                      name="zip_code"
                      max='5'
                      maxLength='5'
                      value={temp_community_info?.address?.zip_code || ''}
                      onPaste={(event) => {
                        if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                          event.preventDefault();
                        }
                      }}
                      onKeyPress={(e) => {
                        const pattern = /[0-9]/;
                        const inputChar = String.fromCharCode(e.charCode);
                        if (!pattern.test(inputChar)) {
                          // invalid character, prevent input
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => { this.updateCommunityAddress(e, 'zip_code') }}
                      placeholder="Zipcode"
                      className="form--control" />
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        }
        {
          loader ?
            <div className='loader_wrapper'>
              <div className='loader07'></div>
            </div>
            : ''
        }
      </div >
    );
  }
}

export default AccountInfo;